import React, { useState, useEffect, useRef } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';

const Gallery = ({ t }) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isAutoPlay] = useState(true);
  const [isPaused, setIsPaused] = useState(false);
  const sectionRef = useRef(null);

  const images = [
    '/images/back pain.png',
    '/images/ankle.png',
    '/images/back pain 1.png',
    '/images/care for old age.png',
    '/images/hand physio care.png',
    '/images/Joint pain.png',
    '/images/knee pain.png',
    '/images/physical fitness.png',
    '/images/rehab.png',
    '/images/spine care.png'
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      const elements = sectionRef.current.querySelectorAll('.fade-in, .scroll-fade-up, .scroll-fade-left, .scroll-fade-right, .scroll-zoom, .scroll-rotate');
      elements.forEach(el => observer.observe(el));
    }

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (isAutoPlay && !isPaused) {
      const interval = setInterval(() => {
        setCurrentSlide(prev => (prev + 1) % images.length);
      }, 4000);
      return () => clearInterval(interval);
    }
  }, [isAutoPlay, isPaused, images.length]);

  const handleMouseEnter = () => {
    setIsPaused(true);
  };

  const handleMouseLeave = () => {
    setIsPaused(false);
  };

  const nextSlide = () => {
    setCurrentSlide(prev => (prev + 1) % images.length);
  };

  const prevSlide = () => {
    setCurrentSlide(prev => (prev - 1 + images.length) % images.length);
  };

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  return (
    <section id="gallery" className="section-padding bg-light" ref={sectionRef}>
      <Container>
        <Row className="justify-content-center text-center mb-5">
          <Col lg={8}>
            <h2 className="section-title scroll-fade-up title-enhance">{t.gallery.title}</h2>
            <p className="section-subtitle scroll-fade-up fade-in-delay-1">{t.gallery.subtitle}</p>
          </Col>
        </Row>

        <Row className="justify-content-center">
          <Col lg={10}>
            <div 
              className="modern-gallery-container scroll-zoom hover-glow animate-shimmer"
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              <div className="gallery-wrapper">
                <div 
                  className="gallery-track"
                  style={{
                    transform: `translateX(-${currentSlide * 100}%)`,
                  }}
                >
                  {images.map((image, index) => (
                    <div key={index} className="gallery-slide">
                      <img
                        src={image}
                        alt={`Clinic ${index + 1}`}
                        className="gallery-image hover-tilt animate-elastic"
                      />
                    </div>
                  ))}
                </div>
                
                <button 
                  className="gallery-nav prev-btn hover-bounce animate-wobble" 
                  onClick={prevSlide}
                  aria-label="Previous image"
                >
                  <FaChevronLeft />
                </button>
                
                <button 
                  className="gallery-nav next-btn hover-bounce animate-swing" 
                  onClick={nextSlide}
                  aria-label="Next image"
                >
                  <FaChevronRight />
                </button>
              </div>

              <div className="gallery-indicators stagger-animation">
                {images.map((_, index) => (
                  <button
                    key={index}
                    className={`gallery-dot hover-scale animate-heartbeat ${currentSlide === index ? 'active' : ''}`}
                    style={{'--i': index}}
                    onClick={() => goToSlide(index)}
                    aria-label={`Go to slide ${index + 1}`}
                  />
                ))}
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Gallery;